// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import ActionButtonBase from './ActionButtonBase';

export default function CompletedButton({
  showButton,
  disabled,
  onClick,
  title,
}: {
  readonly showButton: boolean;
  readonly disabled: boolean;
  readonly onClick: (e: React.MouseEvent | React.TouchEvent) => void;
  readonly title?: string;
}) {
  if (!showButton) {
    return null;
  }

  return (
    <ActionButtonBase
      showButton={showButton}
      disabled={disabled}
      onClick={onClick}
      title={title ?? 'Mark as Complete'}
    />
  );
}
